import { maxDecimals as _decimals } from '@constants/math';

export const roundDown = (number: number, decimals: number = _decimals): number => {
  return Math.floor(number * 10 ** decimals) / 10 ** decimals;
};
